export const Paddings = {
    horizontalPadding: "5em",
    verticalPadding: "1.5em",
    horizontalPaddingMobile: "1em",
    verticalPaddingMobile: "1em",
}